"use client";
import "@/styles/globals.css";
import { GoogleTagManager } from "@next/third-parties/google";
import localFont from "next/font/local";

import ChatbotScript from "@/components/chatbot/ChatbotScript";

const exo2 = localFont({
  src: "./fonts/Exo2VF.ttf",
  variable: "--font-exo2",
  weight: "100 200 300 400 500 600 700 800 900",
});

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <html lang="en">
      <GoogleTagManager gtmId="GTM-TMPCW3G" />
      <body className={`${exo2.variable} overflow-x-hidden antialiased`}>
        <section className="mx-auto h-full max-w-[1920px] bg-gray-50">
          {children}
          <ChatbotScript isEnabled={true} />
        </section>
      </body>
    </html>
  );
}
